import React from 'react';
import Icon from '../../../components/AppIcon';
import useTranslation from '../../../hooks/useTranslation';
import useEscapeKey from '../../../hooks/useEscapeKey';
import DirectiveHistoryList, { useDirectiveHistory } from './DirectiveHistoryList';

/**
 * Historique d'une directive : date · utilisateur · champ · ancien -> nouveau.
 * Lecture seule de entity_change_log, alimente par le trigger de la base.
 * Les suppressions ne sont pas journalisees (le trigger ne voit pas DELETE).
 */
const DirectiveHistoryModal = ({ directive, onClose }) => {
  const { t } = useTranslation();
  const history = useDirectiveHistory(directive?.id);

  useEscapeKey(onClose, !!directive);

  if (!directive) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg flex flex-col max-h-[90vh] overflow-hidden" role="dialog" aria-modal="true">
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-orange-50 flex items-center justify-center">
              <Icon name="History" size={18} className="text-orange-600" />
            </div>
            <div className="min-w-0">
              <h2 className="text-sm font-semibold text-gray-900 leading-snug truncate">{t('extras.directives.history.title')}</h2>
              <p className="text-[11px] text-gray-500 truncate">
                {directive?.nomenclature || '—'}{directive?.title ? ` · ${directive?.title}` : ''}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors flex-shrink-0"
          >
            <Icon name="X" size={16} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          <DirectiveHistoryList history={history} />
        </div>

        <div className="px-5 py-3 border-t border-gray-100 flex-shrink-0">
          <p className="text-[10px] text-gray-400">{t('extras.directives.history.note')}</p>
        </div>
      </div>
    </div>
  );
};

export default DirectiveHistoryModal;
